import * as Colors from "../../../../globalStyles/environmentColors";

export const body = {
    padding: "15px"
};

export const container = {
    background: Colors.primary,
    color: "white",
    padding: "30px",

    borderRadius: "25px"
};

export const topContainer = {
    textAlign: "center"
};

export const categoryHeadings = {
    textAlign: "right",
    fontSize: "1.5rem",
    margin: "auto"
};

export const dropdownText = {
    color: Colors.accent
};

export const dropdownTextError = {
    color: "yellow"
};

export const itemsTable = {
    color: "white",
    textAlign: "center"
};

export const tableHeadings = {
    fontWeight: "bold"
};

export const totalRows = {
    color: "yellow",
    fontWeight: "bold"
};

export const tabRow = {
    padding: "15px"
};

export const tabRow_Second = {
    paddingLeft: "15px",
    paddingRight: "15px"
};

export const tab = {
    backgroundColor: Colors.secondary,
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 0px 0px",
    border: "1px solid",
    cursor: "pointer"
};

export const rowBackground = {
    backgroundColor: Colors.secondary
};

export const m_tab = {
    backgroundColor: Colors.secondary,
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 25px 25px",
    cursor: "pointer"
};

export const selectedTab = {
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 0px 0px",
    backgroundColor: "#163172",
    color: "white",
    fontWeight: "bold",
    borderLeft: "2px solid black",
    borderRight: "2px solid black",
    borderTop: "2px solid black"
};

export const m_selectedTab = {
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 25px 25px",
    backgroundColor: "#163172",
    color: "white",
    fontWeight: "bold",
    border: "2px solid black"
};

export const tabContent = {
    backgroundColor: "white",
    height: "280px",
    borderBottom: "2px solid",
    borderLeft: "2px solid",
    borderRight: "2px solid",
    paddingTop: "10px"
};

export const m_tabContent = {
    backgroundColor: "white",
    border: "2px solid",
    paddingTop: "10px"
};

export const submitBtnCol = {
    textAlign: "right"
};

export const submitBtn = {
    color: Colors.accent
};

export const submitModalTitles = {
    margin: "auto"
};

export const lengthCounter = {
    textAlign: "right",
    color: "red"
};

export const feedbackText = {
    color: "yellow"
};

export const errorText = {
    color: "yelow"
};

export const errorTextHidden = {
    color: "yellow",
    visibility: "hidden"
};

export const counter = {
    color: "yellow",
    textAlign: "right"
};
